<template>
  <a-modal
    title="挂起订单"
    style="top: 20px"
    v-model="visible"
    :width="1200"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
  >
    <!--<s-table-->
    <!--size="default"-->
    <!--ref="table"-->
    <!--:loading="loading"-->
    <!--:columns="columns"-->
    <!--:data="loadData"-->
    <!--bordered-->
    <!--&gt;-->
    <a-table
      size="default"
      ref="table"
      rowKey="modelId"
      :pagination="false"
      :loading="loading"
      :columns="columns"
      :data-source="complaintData"
      :scroll="{ x: 300 }"
      bordered
      :footer="null"
    >
      <span slot="action" slot-scope="text, record">
        <a-button type="primary" @click="editorder(record)">编辑</a-button>

        <a-button style="margin-left: 8px" type="primary" @click="editorder2(record)">取消</a-button>
      </span>
    </a-table>
    <!--分页-->
    <a-pagination
      show-size-changer
      show-quick-jumper
      :default-current="1"
      :total="total"
      @change="onChangePage"
      @showSizeChange="onShowSizeChange"
      style="margin: 30px 10px 10px 0"
    />
    <edit-order-model v-if="$store.state.user_type == 1" ref="editordermodel22" @ok="resetData()"></edit-order-model>
    <edit-order-model1 v-else ref="editordermodel22" @ok="resetData()"></edit-order-model1>
  </a-modal>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  name: 'HoldOrderModel',
  components: {
    editOrderModel: () => import('../order/modules/editOrderModel'),
    editOrderModel1: () => import('../order/modules/editOrderModel1'),
  },
  data() {
    return {
      complaintData: '',
      visible: false,
      queryParam: {},
      columns: [
        {
          title: '序号',
          dataIndex: 'numRow',
          width: '70px',
          align: 'center',
        },
        {
          title: '操作',
          width: '20px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
          width: '100px',
        },
        {
          title: '联系方式',
          dataIndex: 'clientPhone',
          align: 'center',
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          width: '100px',
          align: 'center',
        },
        {
          title: '师傅电话',
          dataIndex: 'masterPhone',
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '创建人',
          dataIndex: 'createBy',
          align: 'center',
        },
      ],
      total: 0,
      pageSize: 10,
      pageNum: 1,
    }
  },
  created() {
    this.$axios({
      method: 'get',
      url: '/api/order/hangUp/list',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8',
      },
    }).then((res) => {
      // this.$store.state.num=res.data.total
      this.$store.commit('changeNum', res.data.total)
    })
  },
  methods: {
    handleSubmit() {
      this.$axios({
        method: 'get',
        url: '/api/order/hangUp/list',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        console.log(res.data.total)
        // this.$store.state.num=res.data.total
        this.$store.commit('changeNum', res.data.total)
        this.visible = false
      })
    },

    editorder(record) {
      this.$nextTick(() => {
        this.$refs.editordermodel22.showeditOrder(record.orderId, '', 1)
      })
      this.visible = false
    },

    // 取消
    editorder2(record) {
      console.log('record', record)
      this.$axios({
        method: 'get',
        url: '/api/order/hangUp/delete',
        params: {
          orderId: record.orderId,
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        console.log(res)
        if (res.data.code == 0) {
          this.$message.success('订单挂起已取消')
          this.visible = true
          this.dataList()
        } else {
          this.$message.error(res.msg)
          this.visible = true
        }
        this.$axios({
          method: 'get',
          url: '/api/order/hangUp/list',
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8',
          },
        }).then((res) => {
          // this.$store.state.num=res.data.total
          this.$store.commit('changeNum', res.data.total)
        })
      })
    },
    // 刷新表格数据
    dataList(data) {
      this.$axios({
        method: 'get',
        url: '/api/order/hangUp/list',
        params: data,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        console.log(res.data)
        this.complaintData = res.data.rows
        this.total = res.data.total
      })
    },
    add() {
      this.dataList({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      })
      this.visible = true
    },
    //分页
    onChangePage(pageNumber) {
      this.pageNum = pageNumber
      this.dataList({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      })
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.pageNum = current
      this.dataList({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      })
    },
  },
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px 16px;
}
</style>